/**
 * Reads a failed lookup save or delete (prescriber, food allergy, diet type, consistency and the
 * other Tables pages). Kept apart from lookupAddModApi so referenceDataApi can use it without an
 * import cycle.
 */
export interface LookupSaveError {
  /** What to show the user. */
  message: string;
  /** The field the server named (`{ error, field }`), for showing the message beside it. */
  field: string | null;
  status: number | null;
  /** Prescriber delete refused (409): how many residents still use it. */
  residentCount: number | null;
}

interface AxiosLike {
  response?: { status?: number; data?: unknown };
}

/**
 * Reads a failed save. The lookup endpoints answer `{ error, field }` (400), `{ error }`
 * (403/404/500) or `{ error, residentCount }` (409); older ones a bare string.
 */
export function lookupSaveError(err: unknown, fallback: string): LookupSaveError {
  const e = (err ?? {}) as AxiosLike;
  const status = typeof e.response?.status === 'number' ? e.response.status : null;
  const data = e.response?.data;
  let message = '';
  let field: string | null = null;
  let residentCount: number | null = null;
  if (typeof data === 'string') {
    message = /^\s*</.test(data) ? '' : data;
  } else if (data && typeof data === 'object') {
    const d = data as Record<string, unknown>;
    if (typeof d.error === 'string') message = d.error;
    else if (typeof d.message === 'string') message = d.message;
    else if (typeof d.title === 'string') message = d.title;
    if (typeof d.field === 'string') field = d.field;
    if (typeof d.residentCount === 'number') residentCount = d.residentCount;
  }
  if (!message && status === 403) message = 'You do not have permission to do that.';
  return { message: message || fallback, field, status, residentCount };
}

